/**
 * メインビジュアルのクラス
 * @requires gsap3
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

import { jquery } from 'jquery';
import $ from 'jquery';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default class ScrollIn {
    constructor() {
        this.init();
    }

    init() {
        this.smoothScroll();
        window.addEventListener('load', this.onScroll);
    }

    onScroll() {
        const revealElm = document.querySelectorAll('.js-scrollreveal');
        [...revealElm].forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: 'top 90%',
                //markers: true,
                onEnter: () => {
                    el.classList.add('-reveal');
                },
            });
        });

        const funcElm = document.querySelectorAll('.js-scrollfunc');
        [...funcElm].forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: 'top 90%',
                //markers: true,
                onEnter: () => {
                    el.classList.add('-scrollin');
                },
            });
        });
    }

    smoothScroll() {
        const triggers = [...document.querySelectorAll('.js-smoothscroll')];
        const pagetop = [...document.querySelectorAll('.js-pagetop')];

        triggers.forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                const hash = el.getAttribute('href');
                const offset = window.innerWidth <= 834 ? window.innerWidth * 0.3 : 100 * (window.innerWidth / 1920);
                gsap.to(window, { duration: 1, scrollTo: { y: hash, offsetY: offset }, ease: 'circ.inOut' });
            });
        });

        pagetop.forEach((el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                gsap.to(window, { duration: 1, scrollTo: { y: 0 }, ease: 'circ.inOut' });
            });
        });
    }
}

